const setGraphData_sell_acc = payload => {
  return {
    type: "setGraphData_sell_acc",
    payload
  };
};
export default setGraphData_sell_acc;
